const META_PIXEL_SCRIPT_ID = "meta-pixel-script";
const META_PIXEL_IDS = ["1372722601029762", "2083296892509504"];

class MetaPixelService {
  private initialized = false;

  enable() {
    if (typeof window === "undefined") return;
    this.bootstrap();
    this.initialized = true;
  }

  disable() {
    if (typeof window === "undefined") return;
    this.initialized = false;

    const existingScript = document.getElementById(META_PIXEL_SCRIPT_ID);
    if (existingScript?.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }

    delete (window as any).fbq;
    delete (window as any)._fbq;
  }

  trackPageView() {
    if (!this.initialized || typeof window === "undefined" || !window.fbq) return;
    window.fbq("track", "PageView");
  }

  private bootstrap() {
    if (window.fbq) return;

    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    };

    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;

    const script = document.createElement("script");
    script.id = META_PIXEL_SCRIPT_ID;
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    META_PIXEL_IDS.forEach((id) => window.fbq?.("init", id));
  }
}

export const metaPixelService = new MetaPixelService();
